import { Outlet, type RouteObject, Navigate } from "react-router-dom";
import DashboardLayout from "../components/feature/DashboardLayout";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import ForgotPasswordPage from "../pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/auth/ResetPasswordPage";
import Dashboard from "../pages/dashboard/page";
import Vehiculos from "../pages/vehiculos/page";
import Movimientos from "../pages/movimientos/page";
import Empresas from "../pages/empresas/page";
import Usuarios from "../pages/usuarios/page";
import Contratos from "../pages/contratos/page";
import Tarifas from "../pages/tarifas/page";
import Planes from "../pages/planes/page";
import Espacios from "../pages/espacios/page";
import Pagos from "../pages/pagos/page";
import Boletos from "../pages/boletos/page";
import Turnos from "../pages/turnos/page";
import Reportes from "../pages/reportes/page";
import AuditoriaPage from "../pages/auditoria/page";
import Facturacion from "../pages/facturacion/page";
import FacturasElectronicas from "../pages/facturas-electronicas/page";
import Configuracion from "../pages/configuracion/page";
import Gastos from "../pages/gastos/page";
import Sedes from "../pages/sedes/page";
import Tienda from "../pages/tienda/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/vehiculos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Vehiculos /></ProtectedRoute>,
      },
      {
        path: "/movimientos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Movimientos /></ProtectedRoute>,
      },
      {
        path: "/empresas",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN']}><Empresas /></ProtectedRoute>,
      },
      {
        path: "/usuarios",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN', 'ADMIN']}><Usuarios /></ProtectedRoute>,
      },
      {
        path: "/contratos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Contratos /></ProtectedRoute>,
      },
      {
        path: "/tarifas",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN', 'ADMIN']}><Tarifas /></ProtectedRoute>,
      },
      {
        path: "/planes",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN']}><Planes /></ProtectedRoute>,
      },
      {
        path: "/espacios",
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Espacios /></ProtectedRoute>,
      },
      {
        path: "/pagos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Pagos /></ProtectedRoute>,
      },
      {
        path: "/boletos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Boletos /></ProtectedRoute>,
      },
      {
        path: "/turnos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Turnos /></ProtectedRoute>,
      },
      {
        path: "/reportes",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN', 'ADMIN']}><Reportes /></ProtectedRoute>,
      },
      {
        path: "/configuracion",
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Configuracion /></ProtectedRoute>,
      },
      {
        path: "/auditoria",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN', 'ADMIN']}><AuditoriaPage /></ProtectedRoute>,
      },
      {
        path: "/facturacion",
        element: <ProtectedRoute allowedRoles={['SUPERADMIN']}><Facturacion /></ProtectedRoute>,
      },
      {
        path: "/facturas-electronicas",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><FacturasElectronicas /></ProtectedRoute>,
      },
      {
        path: "/sedes",
        element: <ProtectedRoute allowedRoles={['ADMIN']}><Sedes /></ProtectedRoute>,
      },
      {
        path: "/tienda",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Tienda /></ProtectedRoute>,
      },
      {
        path: "/gastos",
        element: <ProtectedRoute allowedRoles={['ADMIN', 'OPERADOR']}><Gastos /></ProtectedRoute>,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
